import React from 'react';
import classnames from 'classnames';
import { setQueryParameters } from 'utils/setQueryParameters';

import { Header } from 'components/header/Header';
import { IconButton } from 'components/button/IconButton';
import { CoverVideo } from 'components/video/CoverVideo';
import { PlayButton } from 'components/button/PlayButton';

import s from './SplitPageLayout.module.scss';

type Props = {
  onClose?: () => void;
  children: React.ReactNode;
  imagePosition?: 'top' | 'center' | 'bottom';
};

export const SplitPageLayout = ({ onClose, children, imagePosition = 'center' }: Props) => {
  // const [sections, setSections] = React.useState<any>([]);
  const [currentIndex, setIndex] = React.useState([0, 1]);
  const [logoColor, setLogoColor] = React.useState('dark');

  // const onResize = () => {
  //   const els = Array.from(document.querySelectorAll(`.${s.layout__col} > *`));

  //   const f = els.map((el: HTMLDivElement) => {
  //     const o = { el, top: el.offsetTop, height: el.offsetHeight };

  //     return o;
  //   });

  //   setSections(f);
  // };

  const onScroll = () => {
    const els = Array.from(document.querySelectorAll(`.${s.layout__col} > *`));

    const scrollY = window.pageYOffset;
    const offset = window.innerHeight / 2;

    const f = els.reduce((prev, curr: HTMLDivElement) => {
      if (
        scrollY + offset > curr.offsetTop &&
        scrollY - offset / 2 < curr.offsetTop + curr.offsetHeight
      ) {
        return curr;
      }

      return prev;
    }, undefined);

    if (f) {
      const index = els.indexOf(f);

      setIndex((arr) => {
        if (arr[0] === index) {
          return arr;
        }
        return [index, arr[0]];
      });

      const c = React.Children.toArray(children);
      const item = c[index] as any;

      if (item) {
        setLogoColor(item.props.logoColor ? item.props.logoColor.toLowerCase() : undefined);
      }
    }
  };

  React.useEffect(() => {
    // onResize();
    onScroll();

    window.addEventListener('scroll', onScroll);
    // window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('scroll', onScroll);
      // window.removeEventListener('resize', onResize);
    };
  }, []);

  React.useEffect(() => {
    // console.log(currentIndex);
  }, [currentIndex]);

  return (
    <div className={s.layout}>
      <Header color={logoColor as any} fixed />

      <div className={s.layout__main} id="main">
        <div className={s.layout__container}>
          <div className={s.layout__row}>
            <div className={s.layout__col}>{children}</div>
          </div>
        </div>
      </div>
      <div className={s.layout__side}>
        {React.Children.map(children, (c, i) => {
          const {
            props: { image, alignment = 'center', video, embed },
          } = c as any;

          // override alignment if imagePosition is set
          const align = imagePosition ? imagePosition.toLowerCase() : alignment.toLowerCase();

          if (image) {
            return (
              <div
                className={classnames(s.layout__image, {
                  [s.isVisible]: currentIndex[0] === i,
                  [s.isLeaving]: currentIndex[1] === i,
                  [s.top]: align === 'top',
                  [s.center]: align === 'center',
                  [s.bottom]: align === 'bottom',
                })}
                style={{
                  backgroundImage: image.portrait?.url
                    ? `url(${setQueryParameters(image.portrait.url as string, 'w=1000&h=1500')})`
                    : `url(${image.url})`,
                }}
              >
                {video && video.href && (
                  <CoverVideo className={s.layout__video} video={video.href} />
                )}
                {embed && (
                  <PlayButton className={s.layout__play} embed={embed} ariaLabel={`Play video`} />
                )}
              </div>
            );
          }

          return null;
        })}
      </div>

      {onClose && (
        <div className={s.layout__button} onClick={onClose}>
          <IconButton icon="close" color="white" aria-label="Close" />
        </div>
      )}
    </div>
  );
};
